module.exports = __webpack_public_path__ + "static/media/pnp.b4f432a9.png";